import {useEffect, useState} from "react";
import {Bounds} from "google-map-react";
import {isPointInBounds} from "../utility/googleMapsUtility";
import {Location} from "../types/location";

export function useInBounds(locations : Location[], bounds : Bounds | undefined) {

    const [filteredLocations, setFilteredLocations] = useState<Location[]>(locations)

    useEffect(() => {
        if(bounds === undefined) {
            return;
        }
        setFilteredLocations(
            locations
                .filter((location : Location) => isPointInBounds(bounds, {lat: location.lat, lng: location.lng}))
        )
    }, [locations, bounds])

    return filteredLocations;

}
